export default __webpack_public_path__ + "media/images/stone-stairs-5f3f220b816551f19a3466b406bd5513.jpg";